import { useContext } from 'react';

import { CurrencySelectionContext } from './context';

export const useCurrencySelection = () => {
  const context = useContext(CurrencySelectionContext);

  if (!context) {
    throw new Error('useCurrencySelection must be used within CurrencySelectionProvider');
  }

  return context;
};
